<template>
    <!--<camera :resolution="{ width: 450, height: 250 }" :ref="(e) => (refs.camera = e)" autoplay></camera>-->
    <video :ref="(e) => (refs.camera = e)" :width="450" :height="250" autoplay playsinline v-show="data.isActiveCamera === true"></video>
    <Button @click="snapShot({ props, refs, data })" v-if="data.isActiveCamera === true">ถ่ายภาพ</Button>
    <Button @click="toggleCamera({ refs, data })" v-if="data.isActiveCamera === false">เปิดกล้อง</Button>
    <canvas  id="photoTaken" :ref="(e) => (refs.canvas = e)" :width="450" :height="337"></canvas>
</template>

<script>
    import { defineComponent, reactive} from "vue";
    import { snapShot, createCameraElement, toggleCamera } from "./web-cam.logic";
    import { Button } from "ant-design-vue";

    export default defineComponent({
    components: {
        Button
    },
    props: {
        form: {},
        options: {},
    },
    setup(props) {
        const data = reactive({ isActiveCamera: false });
        const refs = reactive({ camera: null, canvas:null });
        createCameraElement({ props, refs, data })
        return {
            props,
            data,
            refs,
            snapShot,
            toggleCamera
        };
    },
});
</script>